import { SVGProps } from "react";

const UnlockIcon = (props: SVGProps<SVGSVGElement>) => {
  const { width = 13, height = 16, fill = "black" } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.8999 4.9999C1.8999 2.45939 3.95939 0.399902 6.4999 0.399902C9.04041 0.399902 11.0999 2.45939 11.0999 4.9999H9.8999C9.8999 3.12213 8.37767 1.5999 6.4999 1.5999C4.62213 1.5999 3.0999 3.12213 3.0999 4.9999V7.3999H11.3999C11.7865 7.3999 12.0999 7.7133 12.0999 8.0999V13.9999C12.0999 14.8836 11.3836 15.5999 10.4999 15.5999H2.4999C1.61625 15.5999 0.899902 14.8836 0.899902 13.9999V8.0999C0.899902 7.7133 1.2133 7.3999 1.5999 7.3999H1.8999V4.9999ZM2.0999 8.5999V13.9999C2.0999 14.2208 2.27899 14.3999 2.4999 14.3999H10.4999C10.7208 14.3999 10.8999 14.2208 10.8999 13.9999V8.5999H2.0999Z"
        fill={fill}
      />
    </svg>
  );
};

export default UnlockIcon;
